export const getCookie = name => {
	const cookie = document.cookie
		.split("; ")
		.map(item => item.split("="))
		.filter(item => item[0] === name);
	if (cookie.length) {
		return cookie[0][1];
	}
	return null;
};
